export const inlineImageAttribute = 'data-inline-image';
